// Small reassurance line rendered under any "Get a free website audit" CTA.
export default function AuditReassurance({ align = "left", className = "" }) {
    const style = {
        color: "var(--muted-2)",
        fontSize: "12.5px",
        marginTop: 8,
        textAlign: align,
    };
    return (
        <div className={className} style={style} data-testid="audit-reassurance">
            Free, no obligation. Takes 2 minutes to request.
        </div>
    );
}
